import { render, staticRenderFns } from "./DocumentComponent.vue?vue&type=template&id=5288986f&scoped=true"
import script from "./DocumentComponent.vue?vue&type=script&lang=js"
export * from "./DocumentComponent.vue?vue&type=script&lang=js"
import style0 from "./DocumentComponent.vue?vue&type=style&index=0&id=5288986f&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5288986f",
  null
  
)

export default component.exports